// extracted by mini-css-extract-plugin
export default {"moduleCard":"ModuleCard_moduleCard__t635H"};